/* LUVF - make the top-level menu labels clickable.

   Dawn renders a menu item that HAS children as a <summary>, not a link, so
   "Sides" and "Snacks" could only open a dropdown - there was no way to reach
   /pages/menu#sides itself. The parent URL is real (it is set on the LUVF Mega
   Menu in admin), Dawn just throws it away in the markup.

   meta-tags.liquid prints the menu as JSON in #luvf-menu-map. This file reads
   it and:
     - desktop: a click on the label navigates to the parent page (hover still
       opens the dropdown, handled in luvf-motion.js)
     - mobile drawer: prepends an "All <label>" link inside the submenu, because
       on touch the tap has to keep opening the drawer
*/
(function () {
  var el = document.getElementById('luvf-menu-map');
  if (!el) return;

  var map;
  try { map = JSON.parse(el.textContent || '{}'); } catch (e) { return; }

  function labelOf(summary) {
    var span = summary.querySelector('span');
    return (span ? span.textContent : summary.textContent).trim();
  }

  function urlFor(summary) {
    var k = labelOf(summary);
    return map[k] || map[k.toLowerCase()] || null;
  }

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* --- desktop: the label itself is a link --- */
  if (canHover) {
    document.querySelectorAll('.header__inline-menu details > summary').forEach(function (s) {
      var url = urlFor(s);
      if (!url) return;

      s.dataset.luvfHref = url;
      s.style.cursor = 'pointer';

      s.addEventListener('click', function (e) {
        /* let the caret keep its toggle behaviour */
        if (e.target.closest('.icon-caret')) return;
        e.preventDefault();
        e.stopPropagation();
        window.location.href = url;
      });

      /* keyboard: Enter follows the link, Space still opens the menu */
      s.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          window.location.href = url;
        }
      });
    });
  }

  /* --- mobile drawer: add an explicit "All <label>" row --- */
  document.querySelectorAll('.menu-drawer details > summary').forEach(function (s) {
    var url = urlFor(s);
    if (!url) return;

    var panel = s.parentElement.querySelector('ul, .menu-drawer__submenu ul, .menu-drawer__inner-submenu');
    if (!panel || panel.querySelector('[data-luvf-all]')) return;

    var first = panel.querySelector('li');
    if (first && first.textContent.trim().toLowerCase().indexOf('all ') === 0) return;

    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = url;
    a.textContent = 'All ' + labelOf(s);
    a.className = 'menu-drawer__menu-item link link--text list-menu__item focus-inset';
    a.setAttribute('data-luvf-all', '1');
    li.appendChild(a);
    panel.insertBefore(li, panel.firstChild);
  });
})();
